import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top whenever the route changes. Drop this once at the
 * router root.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Use 'auto' to avoid jarring smooth-scroll on every nav.
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}
